export const houseKeepingRouteDef = [
    {
        path: 'clearance_status_housekeeping',
        component: 'TrackStatusComponent',
        data: {
            selector: 'kx-track-status',
            resource: 'encounter_dischargeClearance'
        }
    },
    {
        path: ':resource/patient_clearence',
        component: 'PerPatientTrackStatusComponent',
        data: {
            selector: 'kx-per-patient-track-status',
        }
    },
    {
        path: ':resource/:id/bed-management',
        component: 'BedManagementComponent',
        data: {
            selector: 'app-bed-management'
        }
    },
] 